module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-product-hair-2.548f6987.png";